import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { getNotificationMessage, testNotification, saveNotification } from "actions/notificationActions";
import Loading from "components/Loading";

function ModalSettingNotification({ onSubmit, getNotificationMessage, testNotification, saveNotification }) {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [dataNotification, setDataNotification] = useState({});
    const { t } = useTranslation();

    useEffect(() => {
        getNotificationMessage().then((data) => {
            if (data) {
                setDataNotification(data);
            }
        });
    }, [getNotificationMessage]);

    const handleSubmit = async () => {
        await onSubmit();
        setIsOpen(false);        
        console.log("dataNotification", dataNotification);
        await saveNotification({ ...dataNotification, type: dataNotification?.type || "message_warning" }, setIsLoading);
    };

    const handleTest = async () => {
        await testNotification({ telegramToken: dataNotification?.telegramToken, chat_id: dataNotification?.chat_id, message: "Test Notification Message from Cotik App", type: dataNotification?.type || "message_warning" });
    };

    return (
        <Fragment>
            <button className="btn btn-warning" onClick={() => setIsOpen(true)}>
                <i className="ki-outline ki-notification-on fs-2 m-0 p-0"></i>
            </button>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    setIsOpen(!isOpen);
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Setting Message Token Telegram?")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                setIsOpen(!isOpen);
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <Loading isLoading={loading} />
                    <div className="form-group mb-3">
                        <input className="form-control" placeholder="Chat ID?" type="text" value={dataNotification?.chat_id} name="chat_id" onChange={(e) => {
                            setDataNotification((prev) => (
                                {
                                    ...prev, chat_id: e.target.value
                                }
                            ))
                        }} />
                    </div>
                    <div className="form-group mb-3">
                        <input className="form-control" placeholder="Telegram Token?" type="text" name="telegramToken" value={dataNotification?.telegramToken} onChange={(e) => {
                            setDataNotification((prev) => (
                                {
                                    ...prev, telegramToken: e.target.value
                                }
                            ))
                        }} />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            setIsOpen(!isOpen);
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-warning me-3"
                        onClick={handleTest}
                    >
                        {t("Test")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    getNotificationMessage,
    testNotification,
    saveNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalSettingNotification);
